'use client'

import { Link } from '@/components/ui/deprecated-link'
import { cn } from '@/lib/css-utils'
import { ChartBar, DollarSign } from 'lucide-react'
import { usePathname } from 'next/navigation'

export function SalaryTabs({ salaryCount }: { salaryCount?: string }) {
  const pathname = usePathname()
  const isTrendsTab = pathname.includes('trends')
  const basePath = isTrendsTab ? pathname.replace('/trends', '') : pathname

  const tabs = [
    {
      href: basePath,
      icon: DollarSign,
      label: 'Salaries',
      count: salaryCount,
      isActive: !isTrendsTab,
    },
    {
      href: `${basePath}/trends`,
      icon: ChartBar,
      label: 'Trends',
      isActive: isTrendsTab,
    },
  ]

  return (
    <div className="flex gap-2">
      {tabs.map(({ href, icon: Icon, label, count, isActive }) => (
        <Link
          key={label}
          variant="ghostButton"
          prefetch
          className={cn({ 'bg-button-ghost-hover-bg': isActive })}
          href={href}
        >
          <Icon className="w-5 h-5 mr-1" />
          <span className="font-bold">{label}</span>
          {count && <span className="font-normal ml-1">({count})</span>}
        </Link>
      ))}
    </div>
  )
}
